import { LoaderActions } from '@store/loaders'
import { UPDATE_PROFILE } from '@storeOld/actions'
import { closeModal } from '@storeOld/reducers/ui'
import { call, put } from 'redux-saga/effects'

import API from '@/api'
import { type AccountActions, InternalAccountActions } from '../actions'
import type { AccountUpdateResult } from '../types'

const takeError = (e: unknown) => {
  if (typeof e !== 'object' || !e || !('error' in e)) {
    return 'Unknown error'
  }

  return String(e.error) || 'Unknown error'
}

export function* verifyOtp({
  payload: { otp },
}: ReturnType<typeof AccountActions.verifyOtp>) {
  yield put(LoaderActions.set('change_email_otp_validation'))

  try {
    const updated: AccountUpdateResult = yield call(API.UpdateEmail.verify, {
      code: otp,
    })

    yield put({ type: UPDATE_PROFILE, payload: updated })
    yield put(InternalAccountActions.clearOtp())
    yield put(closeModal())
  } catch (e) {
    yield put(
      InternalAccountActions.updateOtp({
        error: takeError(e),
      })
    )
  } finally {
    yield put(LoaderActions.unset('change_email_otp_validation'))
  }
}
